import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f483781"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-upload" }
const _hoisted_2 = { class: "file-upload-table" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 预览 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("下载")

export function render(_ctx, _cache) {
  const _component_file_status = _resolveComponent("file-status")
  const _component_hmd_empty_link = _resolveComponent("hmd-empty-link")
  const _component_download_file = _resolveComponent("download-file")
  const _component_table_wrapper = _resolveComponent("table-wrapper")
  const _component_a_card = _resolveComponent("a-card")

  return (_openBlock(), _createBlock(_component_a_card, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_table_wrapper, {
            class: _normalizeClass(_ctx.class),
            tableHeight: 34*((_ctx.fileList?.length||4)+1),
            dataSource: _ctx.fileList,
            columns: _ctx.columns,
            showCheckbox: false
          }, {
            size: _withCtx(({ record }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$filters.humanizeFileSize(record.size)), 1)
            ]),
            status: _withCtx(({ record }) => [
              _createVNode(_component_file_status, {
                status: record.status
              }, null, 8, ["status"])
            ]),
            action: _withCtx(({ record }) => [
              (_ctx.allowEdit)
                ? (_openBlock(), _createBlock(_component_hmd_empty_link, {
                    key: 0,
                    onClick: $event => (_ctx.deleteFile(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_hmd_empty_link, {
                onClick: $event => (_ctx.openPreview(record.url))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_download_file, {
                url: record.url,
                fileName: record.name
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["url", "fileName"])
            ]),
            _: 1
          }, 8, ["class", "tableHeight", "dataSource", "columns"])
        ])
      ])
    ]),
    _: 1
  }))
}